import { RiMessage2Line, RiShieldUserLine } from "react-icons/ri";

const iconStyle = {
  fontSize: "24px",
};
const navconfig = {
  Sys_Admin: {
    items: [
      {
        label: "Profile",
        icon: <RiMessage2Line style={iconStyle} />,
        to: "/base/profile",
      },
      {
        label: "Users",
        icon: <RiShieldUserLine style={iconStyle} />,
        to: "/base/users",
      },
      {
        label: "Organizations",
        icon: <RiMessage2Line style={iconStyle} />,
        to: "/base/organization",
      },
      {
        // Modus-only billing view — org/user/duration attribution across
        // all calls. Deliberately NOT added to Org_Admin/user roles below.
        label: "AI Verification Calls",
        icon: <RiMessage2Line style={iconStyle} />,
        to: "/base/ai-verification-calls",
      },
    ],
  },
  Org_Admin: {
    items: [
      {
        label: "Profile",
        icon: <RiMessage2Line style={iconStyle} />,
        to: "/base/profile",
      },
      {
        label: "Users",
        icon: <RiShieldUserLine style={iconStyle} />,
        to: "/base/users",
      },
      {
        // TEMPORARY — for today's demo only. This is meant to be
        // Sys_Admin-only (Modus's internal billing view). Remove this
        // entry once real Sys_Admin login is available for demoing.
        label: "AI Verification Calls",
        icon: <RiMessage2Line style={iconStyle} />,
        to: "/base/ai-verification-calls",
      },
    ],
  },
  user: {
    items: [
      {
        label: "Profile",
        icon: <RiMessage2Line style={iconStyle} />,
        to: "/base/profile",
      },
      {
        // TEMPORARY — same as above, for today's demo only.
        label: "AI Verification Calls",
        icon: <RiMessage2Line style={iconStyle} />,
        to: "/base/ai-verification-calls",
      },
    ],
  },
};
export { navconfig };